import CallIcon from '@/CustomIcons/CallIcon'
import { RoomContext, RoomContextType } from '@/RoomContext'
import { AnalyticsEvents } from '@/services/AnalyticsService'
import useAnalytics from '@/services/useAnalytics'
import useRoomActions from '@/services/useRoomActions'
import { Button } from '@/UIComponents2/Button'
import MenuButton, { MenuItem } from '@/UIComponents2/MenuButton/MenuButton'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

const LeaveSessionMenuButton = () => {
    const { t } = useTranslation()
    const { state: roomState } = useContext(RoomContext) as RoomContextType

    const { leaveRoom } = useRoomActions()
    const { logUserActivityWithContext } = useAnalytics()

    let onIconClick = undefined
    let content = undefined

    if (roomState.isHost) {
        content = (
            <>
                <MenuItem className="w-full">
                    <Button
                        variant="rectangle"
                        className="w-full"
                        onClick={() => {
                            logUserActivityWithContext(AnalyticsEvents.CLICKED_END_SESSION_BUTTON, {
                                componentSource: 'LeaveSessionMenuButton',
                            })
                            leaveRoom({ endSession: true })
                        }}
                    >
                        {t('End Session')}
                    </Button>
                </MenuItem>
                <MenuItem className="w-full">
                    <Button
                        variant="rectangle"
                        className="w-full"
                        onClick={() => {
                            logUserActivityWithContext(AnalyticsEvents.CLICKED_END_SESSION_BUTTON, {
                                componentSource: 'LeaveSessionMenuButton',
                            })
                            leaveRoom({ endSession: false })
                        }}
                    >
                        {t('Leave Session')}
                    </Button>
                </MenuItem>
            </>
        )
    } else {
        onIconClick = () => {
            logUserActivityWithContext(AnalyticsEvents.CLICKED_LEAVE_SESSION_BUTTON, {
                componentSource: 'LeaveSessionMenuButton',
            })
            leaveRoom({ endSession: false })
        }
    }

    return (
        <MenuButton
            triggerClassName="h-[52px]"
            label={t('Leave')}
            icon={<CallIcon className="text-muse-danger" style={{ fontSize: '1.3rem' }} />}
            onIconClick={onIconClick}
            contentClassName="gap-[5px] p-0 min-w-[160px]"
            content={content}
        />
    )
}

export default LeaveSessionMenuButton
